module.exports = __webpack_public_path__ + "img/login-icon.4c53ce11.png";